import { Routes } from '@angular/router';

import { AuthGuard } from '../auth/auth.guard';
import { InteriorDesignToolComponent } from '../public/interior-design-tool/interior-design-tool.component';
import { ProductHealthcheckComponent } from '../public/product-healthcheck/product-healthcheck.component';
import { nonProductionGuard } from '../shared/non-production.guard';
import { BaseComponent } from './base.component';
import { CurrentUserResolve } from './current-user.resolve';
import { HomeComponent } from './home.component';
import { IconsComponent } from './icons/icons.component';

export const BASE_ROUTES: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    resolve: {
      currentUser: CurrentUserResolve
    },
    children: [
      { path: 'home', component: HomeComponent },
      // helpful to list out all icons, not actual app page
      {
        path: 'icons',
        component: IconsComponent
      },
      {
        path: 'users',
        loadChildren: () => import('app/users/users.routing').then(m => m.USERS_ROUTES)
      },
      {
        path: 'management-maps',
        loadChildren: () =>
          import('app/management-maps/management-maps.routing').then(
            m => m.MANAGEMENT_MAPS_ROUTES
          )
      },
      {
        path: 'admin',
        loadChildren: () => import('app/admin/admin.routing').then(m => m.ADMIN_ROUTES)
      },
      {
        path: 'orders',
        loadChildren: () => import('app/orders/orders.routes').then(m => m.ordersRoutes)
      },
      {
        path: 'tools',
        loadChildren: () => import('app/tools/tools.routing').then(m => m.TOOLS_ROUTES)
      },
      {
        path: 'help',
        loadChildren: () => import('app/help/help.routing').then(m => m.HELP_ROUTES)
      },
      {
        path: 'onboarding',
        loadChildren: () =>
          import('app/onboarding/onboarding.routing').then(m => m.ONBOARDING_ROUTES)
      },
      {
        path: '3d-configurator',
        loadChildren: () => import('app/projects/projects.routing').then(m => m.PROJECTS_ROUTES)
      },
      {
        path: 'web-spinner',
        loadChildren: () =>
          import('app/web-spinner/web-spinner.routing').then(x => x.WEB_SPINNER_ROUTES)
      },
      {
        path: 'content-editor',
        loadChildren: () =>
          import('app/content-editor/content-editor.routing').then(m => m.CONTENT_EDITOR_ROUTES)
      },
      {
        path: 'ar-viewer',
        loadChildren: () => import('app/ar-viewer/ar-viewer.routing').then(m => m.AR_VIEWER_ROUTES)
      },
      {
        path: 'data-scrape',
        loadChildren: () =>
          import('app/data-scrape/data-scrape-routing.module').then(m => m.DATA_SCRAPE_ROUTES)
      },
      {
        path: 'pano',
        loadChildren: () => import('app/pano/pano-routing.module').then(m => m.PANO_ROUTES)
      },
      {
        path: 'ai',
        canActivate: [nonProductionGuard],
        loadChildren: () => import('app/ai/ai.routing').then(m => m.AI_ROUTES)
      }
    ]
  },
  {
    path: 'public',
    children: [
      {
        path: 'interior-design-tool',
        component: InteriorDesignToolComponent
      },
      {
        path: 'product-healthcheck',
        component: ProductHealthcheckComponent
      }
    ]
  }
];
